class moreInfo extends HTMLElement {
    constructor() {
        super();

        this.locations = this.querySelector('.more-info__locations');
        this.items = this.querySelectorAll('.more-info__locations-item');
        this.itemContentTriggers = this.querySelectorAll('.more-info__locations-item-header');
        this.form = this.querySelector('.more-info__form');
        this.formInput = this.form.querySelector('input');
        this.formButton = this.form.querySelector('button');
        this.validationMessage = this.querySelector('.more-info__zip-error')
    }

    connectedCallback() {
        this.itemContentTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                trigger.closest('.more-info__locations-item').classList.toggle('active');
            })
        });

        this.formInput.addEventListener('input', () => {
            const sanitizedValue = this.formInput.value.replace(/[^0-9-]/g, '');
            const zipRegex = /^\d{5}(-\d{4})?$/;

            this.formInput.value = sanitizedValue;
            const isValid = zipRegex.test(sanitizedValue);

            if (isValid) {
                this.formButton.disabled = false;
                this.validationMessage.style.display = 'none';
            } else {
                this.formButton.disabled = true;
                this.validationMessage.style.display = 'block';
                this.locations.style.display = 'none';
            }
        });

        this.formInput.addEventListener('blur', () => {
            this.validationMessage.style.display = 'none';
        });

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (this.form.querySelector('input').value.trim() != '') {
                this.distanceFinder(this.form.querySelector('input').value - 0);
            }
        });

    }

    async distanceFinder(zipCode) {

        fetch(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((dataRegion) => {
                const zipLatitude = dataRegion.places[0].latitude - 0;
                const zipLongitude = dataRegion.places[0].longitude - 0;

                this.items.forEach(item => {
                    const itemLatitude = item.getAttribute('latitude') - 0;
                    const itemLongitude = item.getAttribute('longitude') - 0;
                    const itemDistance = item.querySelector('.distance');
                    itemDistance.innerHTML = `${this.haversineDistance(zipLatitude, zipLongitude, itemLatitude, itemLongitude)} mi`
                });

                this.locations.style.display = 'block';

            })
            .catch((error) => {
                this.validationMessage.style.display = "block";
                this.locations.style.display = 'none';
                console.error("There was a problem with the fetch operation:", error);
            });
    }

    haversineDistance(lat1, lon1, lat2, lon2) {
        const R = 3958.8;
        const p1 = lat1 * Math.PI / 180;
        const p2 = lat2 * Math.PI / 180;
        const deltaP = p2 - p1;
        const deltaLon = lon2 - lon1;
        const deltaLambda = (deltaLon * Math.PI) / 180;
        const a = Math.sin(deltaP / 2) * Math.sin(deltaP / 2) +
            Math.cos(p1) * Math.cos(p2) *
            Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
        const d = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * R;
        return d.toFixed();
    }
}

customElements.define("more-info", moreInfo);